/* BBWF back in stock capture on sold out edition cards (Nov 2026).
   Feeds Klaviyo "Subscribed to Back in Stock" so the live Back In Stock flow emails on restock.
   Rollback: remove the script tag that loads this file. */
(function () {
  var COMPANY_ID = 'WFU3Tp';
  var API = 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + COMPANY_ID;
  var variantMap = null;

  function handle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function getVariants() {
    if (variantMap) return Promise.resolve(variantMap);
    var h = handle();
    if (!h) return Promise.resolve({});
    return fetch('/products/' + h + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        variantMap = {};
        p.variants.forEach(function (v) { variantMap[v.title] = v.id; });
        return variantMap;
      });
  }

  function decorate() {
    var cards = document.querySelectorAll('label.bbwf-ed-card.is-soldout');
    cards.forEach(function (card) {
      if (card.querySelector('.bbwf-bis-link')) return;
      var input = card.querySelector('input[type="radio"]');
      var line = card.querySelector('.bbwf-ed-line');
      if (!input || !line) return;
      var title = input.value;

      var link = document.createElement('a');
      link.href = '#';
      link.className = 'bbwf-bis-link';
      link.setAttribute('role', 'button');
      link.setAttribute('aria-expanded', 'false');
      link.textContent = 'Email me when it\u2019s back';
      line.insertAdjacentElement('afterend', link);

      var panel = document.createElement('div');
      panel.className = 'bbwf-bis';
      panel.hidden = true;
      panel.innerHTML =
        '<div class="bbwf-bis-form">' +
          '<label class="bbwf-bis-label">Get one email when <strong></strong> is back in stock.</label>' +
          '<div class="bbwf-bis-row">' +
            '<input type="email" class="bbwf-bis-email" placeholder="Your email" autocomplete="email" inputmode="email">' +
            '<button type="button" class="bbwf-bis-btn">Notify me</button>' +
          '</div>' +
          '<p class="bbwf-bis-msg" role="status" aria-live="polite"></p>' +
        '</div>';
      panel.querySelector('strong').textContent = title;
      panel.dataset.title = title;
      card.insertAdjacentElement('afterend', panel);
    });

    /* Remove panels whose card is no longer sold out */
    document.querySelectorAll('.bbwf-bis').forEach(function (p) {
      var prev = p.previousElementSibling;
      if (!prev || !prev.classList.contains('is-soldout')) p.remove();
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.bbwf-bis-link');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    var card = link.closest('label.bbwf-ed-card');
    var panel = card && card.nextElementSibling;
    if (!panel || !panel.classList.contains('bbwf-bis')) return;
    var open = panel.hidden;
    panel.hidden = !open;
    link.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var field = panel.querySelector('.bbwf-bis-email');
      if (field) field.focus();
    }
  }, true);

  /* Keep typing inside the panel from triggering the theme's variant change or add to cart */
  ['change', 'input', 'keyup'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest('.bbwf-bis')) e.stopPropagation();
    }, true);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest || !e.target.closest('.bbwf-bis')) return;
    e.preventDefault();
    e.stopPropagation();
    send(e.target.closest('.bbwf-bis-form'));
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bbwf-bis-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    send(btn.closest('.bbwf-bis-form'));
  }, true);

  function send(form) {
    if (!form) return;
    var panel = form.closest('.bbwf-bis');
    var field = form.querySelector('.bbwf-bis-email');
    var btn = form.querySelector('.bbwf-bis-btn');
    var msg = form.querySelector('.bbwf-bis-msg');
    if (btn.disabled) return;
    var email = (field.value || '').trim();
    msg.className = 'bbwf-bis-msg';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email.';
      msg.classList.add('is-error');
      field.focus();
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Saving';
    getVariants().then(function (map) {
      var id = map[panel.dataset.title];
      if (!id) throw new Error('variant');
      return fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id } }
            }
          }
        })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      form.querySelector('.bbwf-bis-row').hidden = true;
      form.querySelector('.bbwf-bis-label').hidden = true;
      msg.textContent = 'You\u2019re on the list. We\u2019ll email you as soon as it\u2019s back.';
      msg.classList.add('is-ok');
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Notify me';
      msg.textContent = 'Something went wrong. Please try again or call 877-992-3753.';
      msg.classList.add('is-error');
    });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(decorate, 60); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();